import configs from "../configs/apiConfigs";
import { METHOD_TYPE, CommonApiOptions, BODY_TYPE } from "../constants/api";
import { commonApi } from "../helpers/api";
import { attachHeader } from "../utils/apiHandler";

const BASE_URL = `${configs.SOURCE_URL}concierges_driven`;

const buildQuery = (params: Record<string, any>) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, String(value));
    }
  });
  return query.toString();
};

export const getLoyaltyClinicList = () => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/loyalty-clinic-list/`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getLoyaltyCategory = () => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/loyalty-category/`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getLoyaltyAnalytics = () => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/loyalty-analytics/`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getAllocatedPoints = (params: { page: number; record: number; clinicId?: number | string; category?: string; search?: string; startDate?: string; endDate?: string }) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/allocated-points/?${buildQuery(params)}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getPendingClaims = (params: { page: number; record: number; clinicId?: number | string; category?: string; search?: string; startDate?: string; endDate?: string }) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/pending-claims/?${buildQuery(params)}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getEarnedPoints = (params: { page: number; record: number; clinicId?: number | string; category?: string; search?: string; startDate?: string; endDate?: string }) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/earned-points/?${buildQuery(params)}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getPendingRedeemed = (params: { page: number; record: number; startDate?: string; endDate?: string }) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/pending-redeemed/?${buildQuery(params)}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const approveClaim = (actionId: number) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/approved-claim/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: { actionId: String(actionId) },
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const declineClaim = (actionId: number, reason: string) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/declined-claim/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: { actionId: String(actionId), reason },
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const resubmitClaim = (actionId: number, reason: string) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/resubmit-claim/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: { actionId: String(actionId), reason },
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const approveRedeemed = (redeemedId: number) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/approve-redeemed/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: { redeemedId: String(redeemedId) },
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getRedeemedPoints = (params: { page: number; record: number; search?: string; startDate?: string; endDate?: string }) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/redeemed-points/?${buildQuery(params)}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};
